var exports = {
  "j0": "DirectMessageLayout.module__dmLayoutContainer___NGJTRm",
  "eN": "DirectMessageLayout.module__dmLayoutContainerFullscreen___NGJTRm",
  "Il": "DirectMessageLayout.module__dmListColumn___NGJTRm",
  "qy": "DirectMessageLayout.module__contentColumn___NGJTRm",
  "$f": "DirectMessageLayout.module__contentColumnFullscreen___NGJTRm",
  "YE": "DirectMessageLayout.module__contentInner___NGJTRm",
  "jk": "DirectMessageLayout.module__contentInnerFullscreen___NGJTRm",
};

module.exports = exports;
